module.exports = __webpack_public_path__ + "static/media/hero06.c55cd0ac.jpg";